module.exports = __webpack_public_path__ + "static/media/locations.33eef567.png";